var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['badge', 'badge--small', _vm.cssIconModifier]},[_vm._v(" "+_vm._s(_vm.responseTime)+"ms ")])}
var staticRenderFns = []

export { render, staticRenderFns }